/* Rawdah — fix: keep the gallery slider in sync with the colour-swatch app.
   The Globo swatch app hides the other colours' slides with display:none, but the
   theme's Swiper still counts them. Its autoHeight then measures a hidden slide,
   sets the wrapper to height:0, and the product details ride up over the image.
   Fix: take the hidden slides out of the slider entirely, then rebuild it. */
(function () {
  var HIDDEN = 'globo-sw-media--hide';
  var ORDER = 'data-rw-order';

  function wrapperOf(root) { return root && root.querySelector('.swiper-wrapper'); }

  function storeOf(root) {
    var s = root.querySelector('[data-rw-store]');
    if (!s) { s = document.createElement('div'); s.setAttribute('data-rw-store', ''); s.hidden = true; root.appendChild(s); }
    return s;
  }

  function tagOrder(root) {
    var wrap = wrapperOf(root); if (!wrap) return;
    var all = [].slice.call(wrap.children).concat([].slice.call(storeOf(root).children));
    all.forEach(function (s, i) { if (!s.hasAttribute(ORDER)) s.setAttribute(ORDER, i); });
  }

  function partition(root) {
    var wrap = wrapperOf(root); if (!wrap) return;
    var store = storeOf(root);
    var all = [].slice.call(wrap.children).concat([].slice.call(store.children))
      .filter(function (s) { return s.classList.contains('swiper-slide'); })
      .sort(function (a, b) { return (+a.getAttribute(ORDER)) - (+b.getAttribute(ORDER)); });
    all.forEach(function (s) {
      // Swiper leaves state classes behind; clear them before re-init.
      s.className = s.className.replace(/\bswiper-slide-(active|next|prev|visible|duplicate\S*)\b/g, '').trim();
      s.style.width = '';
      (s.classList.contains(HIDDEN) ? store : wrap).appendChild(s);
    });
  }

  function rebuild(pm) {
    if (!pm || !pm.settings) return;
    // Nothing is being filtered on this product - leave the theme completely alone.
    if (!pm.querySelector('.swiper-slide.' + HIDDEN) && !pm.querySelector('[data-rw-store] .swiper-slide')) return;
    ['mainSlider', 'thumbsSlider'].forEach(function (k) {
      var s = pm.settings[k];
      if (s && s.instance) { try { s.instance.destroy(true, true); } catch (e) {} s.instance = null; }
    });
    [pm.querySelector('[data-main-product-slider]'), pm.querySelector('[data-main-product-thumbs]')]
      .forEach(function (root) { if (root) { tagOrder(root); partition(root); } });
    try { pm.initSlider(); } catch (e) {}
  }

  function boot() {
    var pm = document.querySelector('product-media');
    if (!pm || !pm.settings) return setTimeout(boot, 200);

    // Signature of which media are hidden right now. Swiper churns its own state
    // classes constantly, so only rebuild when this actually changes.
    function signature() {
      return [].slice.call(pm.querySelectorAll('[data-main-product-slider] .swiper-slide, [data-rw-store] .swiper-slide'))
        .map(function (s) { return (s.getAttribute(ORDER) || '') + (s.classList.contains(HIDDEN) ? '1' : '0'); })
        .join(',');
    }

    var last = null, timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var sig = signature();
        if (sig === last) return;
        last = sig;
        rebuild(pm);
        last = signature();
      }, 200);
    }

    schedule();

    // The swatch app re-hides slides on every colour change - rebuild when it does.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'class' && muts[i].target.classList.contains('swiper-slide')) { schedule(); return; }
      }
    }).observe(pm, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
